import { render } from "./VehicleMaintenanceCostReport.vue?vue&type=template&id=2d288316&ts=true&lang=pug"
import script from "./VehicleMaintenanceCostReport.vue?vue&type=script&lang=ts"
export * from "./VehicleMaintenanceCostReport.vue?vue&type=script&lang=ts"

import "./VehicleMaintenanceCostReport.vue?vue&type=style&index=0&id=2d288316&lang=scss"

import exportComponent from "C:\\Users\\ZiegFreeze\\Documents\\Work\\upa-fast-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__